module.exports = __webpack_public_path__ + "static/ORIO-G30218-ce50531c9101415e2c5e6471df64d3b8.png";